/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Delete_DescInputs */

const vi_customer_debt_delete_desc = /** @type {(inputs: Customer_Debt_Delete_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số dư của khách sẽ được tính lại. Nếu là phiếu thu, các đơn đã được trả bằng phiếu này sẽ quay lại trạng thái còn nợ.`)
};

/**

* @param {Customer_Debt_Delete_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_delete_desc = /** @type {((inputs?: Customer_Debt_Delete_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Delete_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_delete_desc(inputs)
});